import { Dispatch, AnyAction } from 'redux';
import { store } from '../../../../appStore';
import { IAppState } from '../../../../models/reduxState';
import {
  areNotesValidSelector,
  isAttachmentsUpdatedSelector,
  isContactsUpdatedSelector,
} from '../selectors/requestDetailsSelectors';
import { dispatchAddNote, dispatchUpdateAttachments, dispatchUpdateContacts } from './contactUsDispatchers';
/**
 * the current usage of mapDispatchToProps is using a function, if we switch to using dictionary of
 * dispatchers then we don't need currying of dispatchers
 * */
export const dispatchUpdateRequest = () => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => IAppState) => {
    const state = store.getState();
    // Update Attachments
    if (isAttachmentsUpdatedSelector(state)) {
      await dispatchUpdateAttachments()(dispatch, getState, null);
    }
    // Update Notes
    if (areNotesValidSelector(state)) {
      await dispatchAddNote()(dispatch, getState, null);
    }
    // updateContacts
    if (isContactsUpdatedSelector(state)) {
      await dispatchUpdateContacts()(dispatch, getState, null);
    }
  };
};
